import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectInfiniteScrollDirective, SearchableSelectorComponent, SearchBarComponentModule } from '@shared/ui';

/**
 * Minimal algorithm fields required for display and selection (identity + list UI).
 */
export interface AlgorithmSelectorItem {
  id: string;
  name: string;
  description: string;
  version: string;
  regulated: boolean;
  deprecated: boolean;
}

@Component({
  selector: 'ts-algorithm-selector',
  templateUrl: './algorithm-selector.component.html',
  styleUrls: ['./algorithm-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSelectInfiniteScrollDirective,
    SearchBarComponentModule,
  ],
})
export class AlgorithmSelectorComponent extends SearchableSelectorComponent<AlgorithmSelectorItem> {
  @Input() value: AlgorithmSelectorItem | null = null;
  @Output() valueChange = new EventEmitter<AlgorithmSelectorItem | null>();

  public readonly tooltipShowDelay = 600;

  onSelectionChange(next: AlgorithmSelectorItem | null): void {
    this.value = next;
    this.valueChange.emit(next);
  }

  clearSelection(event: MouseEvent): void {
    event.stopPropagation();
    this.onSelectionChange(null);
  }

  trackById(_: number, item: AlgorithmSelectorItem): string {
    return item.id;
  }
}
